const breakpoints = {
	xs: "320px",
	sm: "576px",
	md: "768px",
	lg: "992px",
	xl: "1200px",
	xxl: "1728px"
} as const;

export type BreakpointKey = keyof typeof breakpoints;

/**
 * Returns the breakpoint value for a given key
 * @param key The breakpoint key
 * @returns The breakpoint value
 */
export function breakpoint(key: BreakpointKey): string {
	return breakpoints[key];
}
